_ = require 'underscore'
tryBabble = require 'lib/try-babble'
tipsData = require('common/data/tips').default

module.exports = _.filter tipsData, (tip) ->

  # If we don't have it translated, don't include the tip.
  return false if !tryBabble(['templates', 'tips', tip.id])

  if tip.langs
    # If the user's language is in the tip's language array, include it.
    _.contains(tip.langs, window.locale)
  else
    # If there's no lang array, assume it's translated in all languages.
    true



// WEBPACK FOOTER //
// ./app/scripts/lib/filtered-tips.coffee